import React from 'react'
import { Images } from '~/assets'

import Styled from './berthing-info.styles'
import PropTypes from 'prop-types'

const BerthingInfo = ({ data, berthing }) => {
  const size = data.dataBerthing.length
  const jettyName = berthing.jetty_name?.toUpperCase()
  return (
    <Styled.CardHeaderWrapper alignItems={size > 2 ? 'flex-start' : 'center'}>
      <Styled.CardInfoWrapper>
        <Styled.CardInfoImage
          alt={berthing.vessel_name}
          src={berthing.vessel_image || Images.DefaultVesselBerthingManagement}
        />
        <div style={{ width: '100%' }}>
          <Styled.CardInfoTitleWrapper>
            <span style={{ display: 'flex', gap: 8 }}>
              <img alt='anchor-icon' src={Images.AnchorIcon} />
              <Styled.CardInfoTitle fontSize={size === 3 ? '16px' : '22px'}>
                {berthing.vessel_name}
              </Styled.CardInfoTitle>
            </span>
            <Styled.CardBerthPills>
              <Styled.CardInfoBerth>{jettyName}</Styled.CardInfoBerth>
            </Styled.CardBerthPills>
          </Styled.CardInfoTitleWrapper>
          <Styled.CardInfoTextWrapper>
            <Styled.CardInfoText fontSize={size === 2 ? '14px' : '12px'}>Service Request <span>{berthing.sr_no}</span></Styled.CardInfoText>
            <Styled.CardInfoText fontSize={size === 2 ? '14px' : '12px'}>SR Type <span>{berthing.sr_type}</span></Styled.CardInfoText>
            <Styled.CardInfoText fontSize={size === 2 ? '14px' : '12px'}>Client <span>{berthing.client_name}</span></Styled.CardInfoText>
            <Styled.CardInfoText fontSize={size === 2 ? '14px' : '12px'}>SR Category <span>{berthing.sr_category}</span></Styled.CardInfoText>
            <Styled.CardInfoText fontSize={size === 2 ? '14px' : '12px'}>Quantity <span>{berthing.actual}/{berthing.target}</span></Styled.CardInfoText>
            <Styled.CardInfoText fontSize={size === 2 ? '14px' : '12px'}>Material <span>{berthing.material}</span></Styled.CardInfoText>
          </Styled.CardInfoTextWrapper>
        </div>
      </Styled.CardInfoWrapper>
    </Styled.CardHeaderWrapper>
  )
}

const BerthingShape = PropTypes.shape({
  vessel_image: PropTypes.string,
  qty: PropTypes.number.isRequired,
  uom: PropTypes.string.isRequired,
  sr_no: PropTypes.string.isRequired,
  sr_type: PropTypes.string.isRequired,
  material: PropTypes.string.isRequired,
  jetty_name: PropTypes.string.isRequired,
  vessel_name: PropTypes.string.isRequired,
  client_name: PropTypes.string.isRequired,
  sr_category: PropTypes.string.isRequired,
})

BerthingInfo.propTypes = {
  berthing: BerthingShape.isRequired,
  data: PropTypes.shape({
    dataBerthing: PropTypes.arrayOf(BerthingShape).isRequired,
  }).isRequired,
}

export default BerthingInfo